import HandshqApp from '../handshq-app';

HandshqApp.domHelper = {
  toggleElements(elToHide, elToShow) {
    elToHide.hide();
    elToShow.show();
  },

  hoverToggleEvent(element, toggle) {
    if (!HandshqApp.mobileDetect.mobile()) {
      $(element).hover(
        function (_event) {
          $(this).find(toggle).css('visibility', 'visible');
        },
        function (_event) {
          $(this).find(toggle).css('visibility', 'hidden');
        },
      );
    }
  },

  clickStopPropagation(elements) {
    elements.on('click', (event) => {
      event.stopPropagation();
    });
  },
};
